import { render, staticRenderFns } from "./ActivityPushConfig.vue?vue&type=template&id=d0cd9a56&scoped=true"
import script from "./ActivityPushConfig.vue?vue&type=script&lang=js"
export * from "./ActivityPushConfig.vue?vue&type=script&lang=js"
import style0 from "./ActivityPushConfig.vue?vue&type=style&index=0&id=d0cd9a56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cd9a56",
  null
  
)

export default component.exports